<div class="bg-th-blue mt-0 container-fluid position-sticky top-0">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-white my-auto pointer" [routerLink]="iSystemUser != -1 ? ['/saveUser'] : ['/'] "></i>

    </div>

</div>

<div class=" d-flex justify-content-between my-2 container-fluid flex-wrap dirI">

    <div class="dirI col-md-5 col-12">

        <input type="text" class="form-control" autocomplete="one-time-code" (input)="filter($event.target)"

            placeholder="جستجو ">

    </div>
    
    <div class="col-md-6 col-11 d-flex justify-content-start ms-2 d-flex align-items-center ">

        <button *ngIf="!bSchool" 
        
            class="btn btn-primary mx-auto mx-md-2 mt-md-0 mt-3" 
        
            data-bs-toggle="modal" data-bs-target="#addUser">

            ثبت کاربر

        </button>

        <button class="btn btn-success" (click)="exportexcel('excel-table-area-main')">خروجی اکسل</button>

        <p class="my-auto ms-2 f-14 border px-2 rounded" *ngIf="userList">تعداد کل : {{userList.length|faNum}} مورد</p>

    </div>

</div>

<div class="container-fluid mx-auto rounded">

    <div class="table-responsive dirI rounded ">

        <table class="table table-striped  rounded" id="excel-table-area-main">

            <thead class="">

                <tr class="text-center f14">

                    <th scope="col" class="">عملیات</th>

                    <th scope="col" class="pointer" (click)="sortByName()">نام و نام خانوادگی </th>

                    <th scope="col" class="">نام کاربری</th>

                    <th *ngIf="!bSchool" scope="col" class=""> حوزه خدمتی  </th>

                    <th *ngIf="!bSchool" scope="col" class="pointer" (click)="sortByDate()">تاریخ پایان اعتبار </th>

                    <th scope="col" class="pointer" (click)="sortByInput()">تعداد ورود </th>

                    <th *ngIf="!bSchool" scope="col" class="">حداکثر تعداد ورود</th>

                    <th scope="col" class="pointer" (click)="sortByLastLogin()">تاریخ آخرین ورود </th>

                    <th *ngIf="!bSchool" scope="col" class="">تعداد خودرو مجاز</th>

                </tr>

            </thead>

            <tbody>

                <tr class="text-center pointer f12" *ngFor="let item of userList">

                    <th class="text-secondary">

                        <div class="d-flex justify-content-around">

                            <i class="fa fa-ellipsis-h fa-lg pointer me-2" aria-hidden="true" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"></i>

                            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1" style="z-index: 10001!important;">

                                <!-- ویرایش -->

                                <li class="dropdown-li" (click)="editUserModal(item)" data-bs-toggle="modal" data-bs-target="#addUser">

                                    <i class="fa fa-edit fa-lg" title="ویرایش" aria-hidden="true"></i>
                                        
                                    <span> ویرایش </span>

                                </li>

                                <!-- حذف -->

                                <li class="dropdown-li" (click)="deleteUser(item.iSystemUser)">

                                    <i class="fa fa-trash fa-lg" title="حذف" aria-hidden="true"></i>
                                        
                                    <span> حذف </span>

                                </li>

                                <!-- دسترسی -->

                                <li class="dropdown-li" (click)="access(item.iSystemUser)" data-bs-toggle="modal" data-bs-target="#access">

                                    <i class="fa fa-hand-paper-o fa-lg" title="دسترسی" aria-hidden="true"></i>
                                        
                                    <span> دسترسی </span>

                                </li>

                                <!-- اختصاص خودرو -->

                                <li *ngIf="!bSchool" class="dropdown-li" (click)="assignCar(item.iSystemUser)" data-bs-toggle="modal" data-bs-target="#carModal">

                                    <i class="fa fa-car fa-lg" title="اختصاص خودرو" aria-hidden="true"></i>
                                        
                                    <span> اختصاص خودرو </span>

                                </li>

                                <!-- '  تعیین مدارس کاربر ' : 'حوزه خدمتی کاربر ' -->

                                <li *ngIf="(!bSchool && bAcssess.bUserManagment) || bSchool" class="dropdown-li" (click)="getUserSchool(item)"  data-bs-toggle="modal" data-bs-target="#defineSchool">

                                    <i class="fa fa-university fa-lg" [title]="bSchool ? '  تعیین مدارس کاربر ' : 'حوزه خدمتی کاربر ' " aria-hidden="true"></i>
                                        
                                    <span> {{ bSchool ? '  تعیین مدارس کاربر ' : 'حوزه خدمتی کاربر '  }} </span>

                                </li>

                                <!-- گروه کاربری -->

                                <li *ngIf="!bSchool && bAcssess.bUserManagment_Group" class="dropdown-li" (click)="getUserGroup(item)">

                                    <i class="fa fa-user-circle fa-lg"  aria-hidden="true"></i>
                                        
                                    <span> گروه کاربری </span>

                                </li>

                                <!-- حوزه های خدمتی تحت نظارت کاربر -->

                                <li *ngIf="!bSchool && bAcssess.bUserManagment" class="dropdown-li" (click)="getUserSchool(item,'supervision_service')"  data-bs-toggle="modal" data-bs-target="#supervision_service">

                                    <i class="fa fa-building fa-lg"  aria-hidden="true"></i>
                                        
                                    <span> حوزه های خدمتی تحت نظارت کاربر </span>

                                </li>

                                <!-- سابقه فعالیت کاربر -->

                                <li class="dropdown-li" (click)="userHistory(item.iSystemUser)" data-bs-toggle="modal" data-bs-target="#userActive">

                                    <i class="fa fa-list fa-lg"  aria-hidden="true"></i>
                                        
                                    <span> سابقه فعالیت کاربر </span>

                                </li>

                                <!-- زیر مجموعه -->

                                <li *ngIf="!bSchool" class="dropdown-li" (click)="openSubset_Modal(item.iSystemUser)">

                                    <i class="fa fa-users fa-lg"  aria-hidden="true"></i>
                                        
                                    <span> زیر مجموعه </span>

                                </li>

                                <!-- کلاس کاربر -->

                                <li *ngIf="!bSchool && bAcssess.bSchoolService_UserGradeClass" class="dropdown-li" (click)="getClassInitialize(item)">

                                    <i class="fa fa-building fa-lg"  aria-hidden="true"></i>
                                        
                                    <span> کلاس کاربر </span>

                                </li>

                            </ul>
                            
                        </div>

                    </th>

                    <th class="text-dark">{{item.strFullName | faNum }}</th>

                    <th class="text-dark">{{item.strUserName | faNum}}</th>

                    <th *ngIf="!bSchool" class="text-dark">{{item.strMobile_strComment |faNum}}</th>

                    <th *ngIf="!bSchool" class="text-dark">{{item.strEsterakEndDate|faNum}}</th>

                    <th class="text-dark">{{item.iInput|faNum}}</th>

                    <th *ngIf="!bSchool" class="text-dark">{{item.iMaxInput|faNum}}</th>

                    <th class="text-dark">{{item.strLastLoginDateTime |faNum}}</th>

                    <th *ngIf="!bSchool" class="text-dark">{{item.iMaxMobile|faNum}}</th>

                    

                </tr>

            </tbody>

        </table>

    </div>

</div>

<!-- Modal -->

<div class="modal fade" id="addUser" tabindex="-1" aria-labelledby="addUserLabel" aria-hidden="true">

    <div class="modal-dialog ">

        <div class="modal-content" style="direction: rtl;">

            <div class="modal-header d-flex justify-content-between">

                <h5 class="modal-title" id="addUserLabel"> ثبت کاربر </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body" [formGroup]="saveUser">
                <div class="d-flex justify-content-around flex-wrap">
                    <div class=" col-12 p-2">
                        <label>نام کاربری</label>
                        <div class="d-flex">
                            <input class="form-control ms-1" type="text" formControlName="strUserName">
                        </div>
                        <label>موبایل</label>
                        <div class="d-flex">
                            <input class="form-control ms-1" type="text" formControlName="strMobile"
                                (keypress)="isNumber($event)">
                            <button class="btn btn-primary" (click)="checkMobile()" *ngIf="!editMod">بررسی</button>
                        </div>

                    </div>
                    <div *ngIf="addUserInp" class="w-100">
                        <div class="col-12 p-2">
                            <label>نام و نام خانوادگی</label>
                            <input class="form-control" type="text" autocomplete="one-time-code"
                                formControlName="strFullName">
                        </div>
                        <div class=" col-12 p-2">
                            <label>رمز عبور</label>
                            <input class="form-control" type="password" autocomplete="one-time-code"
                                formControlName="strPassword">
                        </div>

                        <div class="col-12 p-2">
                            <label>حداکثر تعداد ورود</label>
                            <input class="form-control" type="number" formControlName="iMaxInput">
                        </div>
                        <div class="col-12 p-2">
                            <label>حداکثر تعداد خودرو مجاز</label>
                            <input class="form-control" type="number" formControlName="iMaxMobile">
                        </div>
                        <div class=" col-12 p-2">
                            <label>تاریخ اعتبار</label>
                            <div>
                                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                                    [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">
                                    <input type="text" formControlName="strEsterakEndDate"
                                        class="form-control shadow text-end" readonly />
                                </ng-persian-datepicker>
                            </div>

                        </div>
                        <div class="col-12 p-2 d-flex flex-wrap">
                            <div>
                                <input formControlName="bEnable" value="true" class="form-check-input" type="radio"
                                    name="bEnable" id="flexRadioDefault1">
                                <label class="form-check-label" for="flexRadioDefault1">
                                    فعال
                                </label>
                            </div>


                            <div class="ms-3">
                                <input formControlName="bEnable" value="false" class="form-check-input " type="radio"
                                    name="bEnable" id="flexRadioDefault2">
                                <label class="form-check-label" for="flexRadioDefault2">
                                    غیر فعال
                                </label>
                            </div>



                        </div>

                    </div>

                </div>
            </div>

            <div class="modal-footer">

                <button *ngIf="addUserInp &&!editMod" type="button" class="btn btn-primary"
                    (click)="addUser()">ثبت</button>
                <button *ngIf="addUserInp &&editMod" type="button" class="btn btn-warning"
                    (click)="edit()">ویرایش</button>
            </div>

        </div>

    </div>

</div>

<!--car Modal-->

<div class="modal fade" id="carModal" tabindex="-1" aria-labelledby="carModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header dirI">
                <h5 class="modal-title" id="carModalLabel">اختصاص خودرو</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body ">
                <div class="d-flex mb-2 flex-wrap dirI">
                    <div class="dirI col-md-5 col-11 mx-auto mx-md-0">
                        <input type="text" id="filterModal" class="form-control" autocomplete="one-time-code"
                            (input)="filterCar($event.target)" placeholder="جستجو ">
                    </div>
                    <div class="dirI col-md-5 col-12 mt-md-0 mt-2 justify-content-around d-flex">
                        <button class="btn btn-warning" (click)="addAllCar()">اضافه کردن همه</button>
                        <button class="btn btn-danger" (click)="removeAllCar()">حذف همه</button>
                        <button class="btn btn-primary" *ngIf="bAcssess.bSendSMS2MobilesUser" data-bs-toggle="modal"
                            data-bs-target="#SmsModal">ارسال پیامک</button>
                        <button class="btn btn-success" (click)="exportexcel('exel-car')">خروجی اکسل</button>
                    </div>
                    <div class="dirI col-md-5 col-11 mx-auto mx-md-0">
                        <input type="text" id="filterModal" class="form-control mt-2" autocomplete="one-time-code"
                            (keyup)="filterCarMobileDomain($event.target)" placeholder=" جستجو بر اساس حوزه خدمت ">
                    </div>
                    <span *ngIf="countBHas >= 0" class="p-3">تعداد موارد انتخاب شده: {{countBHas | faNum}} مورد</span>
                </div>


                <div class="table-responsive dirI rounded" style="max-height: 60vh;">
                    <table class="table table-bordered rounded" id="exel-car">
                        <thead class="bg-secondary">
                            <tr class="text-center f14">
                                <th scope="col" class="text-white">#</th>
                                <th scope="col" class="text-white pointer" (click)="filterAdd()">اختصاص</th>
                                <th scope="col" class="text-white">نام راننده</th>
                                <th scope="col" class="text-white">کد شناسایی خودرو</th>
                                <th scope="col" class="text-white">شماره موبایل راننده</th>
                                <th scope="col" class="text-white">حوزه خدمت</th>
                                <th scope="col" class="text-white">گروه خودرو</th>
                                <th scope="col" class="text-white">پلاک</th>
                                <th scope="col" class="text-white">تاریخ پایان اعتبار</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="text-center f12" *ngFor="let item of assignCarList;let i=index">
                                <th class="text-dark">{{i+1 | faNum}}</th>
                                <th class="text-dark">
                                    <input class="form-check-input" type="checkbox" id="checkedCheckBoxes" value="" checked
                                        *ngIf="item.bHas!=0" (click)="addOrRemoveCar(item.strUnitID)">
                                    <input class="form-check-input" type="checkbox" value="" *ngIf="item.bHas==0"
                                        (click)="addOrRemoveCar(item.strUnitID)">
                                    <span class="d-none" *ngIf="item.bHas!=0">true</span>
                                    <span class="d-none" *ngIf="item.bHas==0">false</span>
                                </th>
                                <th scope="col" class="text-dark">{{item.strFullName}}</th>
                                <th scope="col" class="text-dark">{{item.strUnitID | faNum}}</th>
                                <th scope="col" class="text-dark">{{item.strSystemUser_strMobile | faNum}}</th>
                                <th scope="col" class="text-dark">{{item.strMobileDomain_strComment | faNum}}</th>
                                <th scope="col" class="text-dark">{{item.strMobileGroup_strComment | faNum}}</th>
                                <th scope="col" class="text-dark">{{otherService.returnCorrectPlate(item.strVehicleNo |
                                    faNum)}}</th>
                                <th scope="col" class="text-dark">{{item.strValidDate | faNum}}</th>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    </div>
</div>

<!--Access-->

<div class="modal fade" id="access" tabindex="-1" aria-labelledby="accessLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header dirI">
                <h5 class="modal-title" id="accessLabel">دسترسی</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">

                <div class="d-flex mb-2 flex-wrap dirI">
                    <div class="dirI col-md-5 col-11 mx-auto mx-md-0">
                        <input type="text" id="filterModal" class="form-control" autocomplete="one-time-code"
                            (keyup)="filterAccess($event.target)" placeholder="جستجو ">
                    </div>
                    <div class="dirI col-md-5 col-11 mt-md-0 mt-2 justify-content-around d-flex">
                        <button class="btn btn-success" (click)="addAllAccess()">اضافه کردن همه</button>
                        <button class="btn btn-danger" (click)="removeAllAccess()">حذف همه</button>
                    </div>
                </div>


                <div class="table-responsive dirI rounded" style="max-height: 60vh;">
                    <table class="table table-bordered rounded" id="">
                        <thead class="bg-secondary">
                            <tr class="text-center f14">
                                <th scope="col" class="text-white">#</th>
                                <th scope="col" class="text-white" (click)="filterAddAccess()">اختصاص</th>
                                <th scope="col" class="text-white">نوع دسترسی</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr class="text-center f12" *ngFor="let item of fullAccessSystem;let i=index">
                                <th class="text-secondary">{{i+1}}</th>
                                <th class="text-secondary">
                                    <input class="form-check-input" type="checkbox" value="" checked
                                        *ngIf="item.bHas!=0" (click)="addOrRemoveAccess(item.strXenotakAbility)">
                                    <input class="form-check-input" type="checkbox" value="" *ngIf="item.bHas==0"
                                        (click)="addOrRemoveAccess(item.strXenotakAbility)">
                                </th>
                                <th scope="col" class="text-secondary">{{item.strComment}}</th>

                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    </div>
</div>

<!--ارسال پیامک-->

<div class="modal fade" id="SmsModal" tabindex="-1" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="btn-close " data-bs-dismiss="modal" aria-label="Close"></button>
                <h5 class="modal-title  ms-0" id="">ارسال پیامک</h5>
            </div>
            <div class="modal-body">
                <div class="col-10 mx-auto  dirI" [formGroup]="sendSmsModel">
                    <label>متن پیام</label>
                    <textarea formControlName="strSMS" placeholder="متن پبامک" class="form-control mx-auto " id="smsTxt"
                        rows="3 "></textarea>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="sendSms()">ارسال پیام</button>
                <button type="button" class="btn btn-danger" data-bs-toggle="modal"
                    data-bs-target="#carModal">برگشت</button>
            </div>
        </div>
    </div>
</div>

<!--User Activity-->

<div dir="rtl" class="modal fade" id="userActive" tabindex="-1" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="">فعالیت کاربر</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body ">
                <input class="form-control col-10" placeholder="جستجو بر اساس تاریخ یا نوع اقدام"
                    (keyup)="search($event)" />

                <div class="table-responsive dirI rounded " style="max-height: 60vh;">
                    <table class="table table-striped rounded " id="excel-table-area-log">
                        <thead>
                            <tr class="text-center f14 ">
                                <th scope="col">#</th>
                                <th scope="col">نام</th>
                                <th scope="col">نوع اقدام</th>
                                <th scope="col">تاریخ</th>
                                <th scope="col">زمان</th>
                                <th scope="col">توضیحات</th>
                                <th scope="col">IP</th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr class="text-center pointer f12 " *ngFor="let item of userActivity;let i=index ">
                                <th class="text-secondary ">{{i+1|faNum}}</th>
                                <th class="text-secondary ">{{item.strFullName}}</th>
                                <th class="text-secondary ">{{item.strActionType_strComment}}</th>
                                <th class="text-secondary ">{{item.strDate|faNum}}</th>
                                <th class="text-secondary ">{{item.strTime|faNum}}</th>
                                <th class="text-secondary ">{{item.strAddress |faNum}}</th>
                                <th class="text-secondary"><a class="text-decoration-none text-primary pointer" target="_blank" href="https://whatismyipaddress.com/ip/{{item.strIP}}">{{item.strIP |faNum}}</a></th>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn  btn-success" (click)="exportexcel('excel-table-area-log')">خروجی اکسل</button>
            </div>
        </div>
    </div>
</div>

<!-- Define School -->

<div class="modal fade" id="defineSchool" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-lg modal-dialog-centered">

        <div class="modal-content">

            <div class="modal-header">

                <button type="button" class="btn-close " data-bs-dismiss="modal" aria-label="Close"></button>

                <h5 class="modal-title  ms-0" id="">  {{!bSchool ? ' تعیین حوزه خدمت ' : 'تعیین مدارس کاربر' }}</h5>

            </div>

            <div class="modal-body" dir="rtl"> 

                <div class="row gx-2 mt-1 border border-2 ">

                    <div class="col-12 p-3">
            
                        <input type="search" #search (input)="searchBy(search.value)" class="form-control" placeholder="جستجو کنید">
            
                    </div>

                    <div class="table-responsive " style="max-height: 75vh;">

                        <table class="table table-striped">
            
                            <thead class="position-sticky top-0 bg-white">
            
                                <tr class="col-12 text-center">
            
                                    <th *ngIf="bSchool"> اختصاص </th>
            
                                    <th> {{!bSchool ? 'حوزه خدمت' : 'نام مدرسه' }} </th>
                        
                                </tr>
            
                            </thead>
            
                            <tbody>
            
                                <tr [ngClass]="!bSchool ? 'pointer' : '' " (click)="!bSchool ? onClickMobileDomain(item,i) : '' " class="text-center col-12 " *ngFor="let item of list_schools;let i = index">
            
                                    <td *ngIf="bSchool"><input type="checkbox" (change)="onCheckbox_($event.target.checked,item)" [checked]="item.bSelected == 1 ? true : false "></td>
            
                                    <td> {{ !bSchool ? item.strComment : item.strCombinedDescription | faNum }}</td>
                        
                                </tr>
            
                            </tbody>
            
                        </table>
            
                    </div>

                </div>
                
            </div>

            <div class="modal-footer">

            </div>

        </div>

    </div>

</div>

<!-- supervision_service -->

<div class="modal fade" id="supervision_service" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-xl modal-dialog-centered">

        <div class="modal-content">

            <div class="modal-header">

                <button type="button" class="btn-close " data-bs-dismiss="modal" aria-label="Close"></button>

                <h5 class="modal-title  ms-0" id=""> تعیین حوزه های خدمتی تحت نظارت کاربر </h5>

            </div>

            <div class="modal-body" dir="rtl"> 

                <div class="row gx-2 mt-1 border border-2 ">

                    <div class="col-12 p-3">
            
                        <input type="search" #search2 (input)="searchBy(search2.value)" class="form-control" placeholder="جستجو کنید">
            
                    </div>

                    <div class="table-responsive " style="max-height: 75vh;">

                        <table class="table table-striped">
            
                            <thead class="position-sticky top-0 bg-white">
            
                                <tr class="col-12 text-center">
            
                                    <th > اختصاص </th>
            
                                    <th> حوزه خدمت </th>
                        
                                </tr>
            
                            </thead>
            
                            <tbody>
            
                                <tr  class="text-center col-12 " *ngFor="let item of list_schools;let i = index">
            
                                    <td ><input type="checkbox" (change)="onCheckbox_($event.target.checked,item,'supervision_service')" [checked]="item.bSelected == 1 ? true : false "></td>
            
                                    <td>{{item.strComment | faNum}}</td>
                        
                                </tr>
            
                            </tbody>
            
                        </table>
            
                    </div>

                </div>
                
            </div>

            <div class="modal-footer">

            </div>

        </div>

    </div>

</div>

<!-- گروه کاربری -->

<div class="modal fade" id="Access_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> گروه کاربری </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div class="section border border-2 mt-2" style="max-height:60vh;overflow: auto;">

                    <table class="col-12 table table-striped rounded-3" id="Export_Excel">
        
                        <thead>
        
                            <tr class="">
        
                                <th class="text-center col-1"> # </th>
        
                                <th class="text-center"> عنوان </th>
        
                            </tr>
        
                        </thead>
        
                        <tbody>
        
                            <tr class="col-12 text-center pointer" *ngFor="let item of lst_Roles;let i = index" (click)="selectUserGroup(item)">
        
                                <th> {{ i + 1 | faNum }} </th>
        
                                <td> {{ item.strComment }} </td>
            
                            </tr>
        
                        </tbody>
        
                    </table>
        
                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

            </div>

        </div>

    </div>

</div>

<!-- گروه کاربری -->

<div class="modal fade" id="GradeClass_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> کلاس کاربر </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div class="col-12 d-flex justify-content-end">

                    <button class="btn btn-success" (click)="addUserClass()"> 

                        افزودن
                        
                    </button>

                </div>
                
                <div class="section border border-2 mt-2" style="max-height:60vh;overflow: auto;">

                    <table class="col-12 table table-striped rounded-3" id="Export_Excel">
        
                        <thead>
        
                            <tr class="">
        
                                <th class="text-center col-1"> # </th>
        
                                <th class="text-center"> عملیات </th>

                                <th class="text-center col-5"> مدرسه </th>

                                <th class="text-center"> پایه </th>

                                <th class="text-center"> کلاس </th>
        
                            </tr>
        
                        </thead>
        
                        <tbody>
        
                            <tr class="col-12 text-center pointer" *ngFor="let item of lst_GradeClass;let i = index">
        
                                <th> {{ i + 1 | faNum }} </th>
        
                                <td class=""> 

                                    <i title="حذف" class="fa fa-trash text-danger fa-lg" (click)="deleteGradeClass(item.iSchool_SystemUserGradeClass,i)"></i>
                                    
                                </td>

                                <td class="col-5"> {{ item.strCombinedDescription }} </td>

                                <td> {{ item.strGrade }} </td>

                                <td> {{ item.strTitel }} </td>
            
                            </tr>
        
                        </tbody>
        
                    </table>
        
                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">
                
                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<!--  -->

<div class="modal fade" id="UserClassModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> افزودن </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                    <div [formGroup]="mdl_UserClass" class="container-fluid row gx-2 gy-3 p-2">

                        <!-- مدرسه -->

                        <div *ngIf="list_schools.length" class="col-12 position-relative">

                            <label class="mb-2 text-muted"> مدرسه </label>

                                <custom-filter 
    
                                    [strComment]="'strComment'" 
                                    
                                    [stylesArray]="['padding-top: 10px']" 
                                    
                                    [str_Placeholder]="'نام مدرسه را جستجو کنید'"

                                    [lst_Main]="list_schools" 
                                    
                                    [lst_SearchKey]="['strComment']" 
                                    
                                    [isDisabled]="false"

                                    (hideOptions)="mdl_UserClass.get('iMobileDomain')?.setValue($event?.iMobileDomain || '')">

                                </custom-filter>

                        </div>

                        <!-- پایه -->

                        <div class="col-12 position-relative">

                            <label class="mb-2 text-muted"> پایه </label>

                            <select class="form-select p-2" formControlName="tiGrade">

                                <option class="text-center" value="-1"> انتخاب کنید </option>

                                <option class="text-center" *ngFor="let item of lst_Grade" [value]="item.tiGrade">

                                    {{item.strGrade}}

                                </option>

                            </select>

                        </div>

                        <!-- کلاس -->

                        <div class="col-12 position-relative">

                            <label class="mb-2 text-muted"> کلاس </label>

                            <select class="form-select p-2" formControlName="tiClassNo">

                                <option class="text-center" value="-1"> انتخاب کنید </option>

                                <option class="text-center" *ngFor="let item of lst_ClassNo" [value]="item.tiClassNo">

                                    {{item.strTitel}}

                                </option>

                            </select>

                        </div>

                    </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-success" (click)="submitUserClass()">

                    &nbsp; &nbsp; ثبت &nbsp; &nbsp;

                </button>

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>
